import { AlertTriangle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { components } from '@/types/strapi';
import { SingleColumnPopupProps } from './SingleColumnPopup';

interface SingleColumnAgeVerificationProps
	extends Omit<SingleColumnPopupProps, 'content'> {
	content: components['schemas']['PopupSingleColumnAgeVerificationComponent'];
}

export const SingleColumnAgeVerification = ({
	content,
}: SingleColumnAgeVerificationProps) => {
	const confirmText = content?.confirm_button_text || 'Yes, I am 18+';
	const cancelText = content?.cancel_button_text || 'No, I am under 18';

	return (
		<div className="age-verification w-full">
			<div className="mt-2 px-8 pb-8">
				{content.alert_content && (
					<div className="mb-6 flex items-start rounded-md bg-orange-50 p-4">
						<AlertTriangle className="mr-3 mt-0.5 h-5 w-5 flex-shrink-0 text-orange-500" />
						<p className="text-sm text-orange-800">
							{content.alert_content}
						</p>
					</div>
				)}

				<div className="flex flex-col justify-center gap-4 md:flex-row">
					<Button
						className="flex-1 py-6 text-base"
						variant="primary"
						size="lg">
						{confirmText}
					</Button>

					<Button
						className="flex-1 py-6 text-base"
						variant="outline"
						size="lg">
						{cancelText}
					</Button>
				</div>

				<div className="mt-4 text-center text-xs text-gray-500">
					{content.message}
				</div>
			</div>
		</div>
	);
};
